<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M20.334 16a4.333 4.333 0 11-8.667 0 4.333 4.333 0 018.667 0z"/><path fill-rule="evenodd" d="M16 2.666a1 1 0 011 1v2.048a10.337 10.337 0 019.286 9.285h2.048a1 1 0 010 2h-2.048A10.337 10.337 0 0117 26.285v2.048a1 1 0 11-2 0v-2.048a10.337 10.337 0 01-9.285-9.286H3.667a1 1 0 110-2h2.048A10.337 10.337 0 0115 5.714V3.666a1 1 0 011-1zm-.998 5.06A8.337 8.337 0 007.726 15a1 1 0 010 1.997 8.337 8.337 0 007.276 7.275 1 1 0 011.997 0 8.337 8.337 0 007.276-7.275 1 1 0 010-1.997 8.337 8.337 0 00-7.276-7.276 1 1 0 01-1.997 0z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'objectsCompassOutline'
}
</script>
